import { render, staticRenderFns } from "./CulqiForm.vue?vue&type=template&id=1bac6022&scoped=true"
import script from "./CulqiForm.vue?vue&type=script&lang=js"
export * from "./CulqiForm.vue?vue&type=script&lang=js"
import style0 from "./CulqiForm.vue?vue&type=style&index=0&id=1bac6022&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bac6022",
  null
  
)

export default component.exports